export default __webpack_public_path__ + "static/logo-8d50abba9ed5b88f11763ad40bc5936b.png";